import styles from "./FilterDateRange.module.scss";

export type DateRange = { from?: string; to?: string };

type FilterDateRangeProps = {
  label: string;
  name: string;
  value: DateRange;
  onChange: (value: DateRange) => void;
};

export function FilterDateRange({
  label,
  name,
  value,
  onChange,
}: FilterDateRangeProps) {
  return (
    <div className={styles.range}>
      <span className={styles.label}>{label}</span>
      <div className={styles.inputs}>
        <input
          type="date"
          name={`${name}-from`}
          aria-label={`${label} — du`}
          className={styles.input}
          value={value.from ?? ""}
          onChange={(e) =>
            onChange({ ...value, from: e.target.value || undefined })
          }
        />
        <span className={styles.separator}>→</span>
        <input
          type="date"
          name={`${name}-to`}
          aria-label={`${label} — au`}
          className={styles.input}
          value={value.to ?? ""}
          onChange={(e) =>
            onChange({ ...value, to: e.target.value || undefined })
          }
        />
      </div>
    </div>
  );
}
